import React, { useState } from 'react';
import '../../entrydoor.css';

const MagnetLatch = ({ value, onChange, label = 'Magnet Latch:', disabled = false }) => {
    const [selectedMagnetLatch, setSelectedMagnetLatch] = useState(value || 'No');

    const handleMagnetLatchChange = (e) => {
        setSelectedMagnetLatch(e.target.value);
        onChange(e.target.value);
    };

    return (
        <div className="a-container">
            <label disabled={disabled}  htmlFor="MagnetLatch">{label}</label>
            <select
                disabled={disabled} 
                id="MagnetLatch"
                value={selectedMagnetLatch}
                onChange={handleMagnetLatchChange}
            >
                <option value="" disabled hidden>Select an option</option>
                <option value='No'>{selectedMagnetLatch === 'No' ? 'No ✔' : 'No'}</option>
                <option value='Yes'>{selectedMagnetLatch === 'Yes' ? 'Yes" ✔' : 'Yes'}</option>
            </select>
        </div>
    );
};

export default MagnetLatch;
